// extracted by mini-css-extract-plugin
module.exports = {"header":"InlineHeader_header__1J-Ic"};